export const TENANT_IDS_RUNNING_DEMOS = [
	"2T2UtNPyBtUj0d96TIpFM9XxsdW",
	"2T2UwMs69PZcFn1cyReQUia7Esa",
	"2SMc2vwKKLXhxw74mQ8MD0lklYV",
];
